<template>
  <div class="container">
    <NewBaseFrame
      :breadcrumb="breadcrumb"
      :btns="computedBtns"
      @btn-click="handleBtns"
    >
    <div slot="info">
      <slot name="info"></slot>
    </div>
    <div slot="content">
      <div id="step-background" class="step-padding">
        <ApprovalFlow :workNo="workNo" class="steps-wrap" @handleOver='val=>{isDone=val}' @showQualityOpinions='val=>{showQualityOpinions=val}' @attachmentValue='attachmentValue'/>
      </div>
      <slot name="tableInfo"></slot>
      <slot name="formInfo"></slot>
    </div>
    </NewBaseFrame>
    <lk-modal v-model="ideaInput" :closable="false" :mask-closable="false">
      <p slot="header">
        <span>审批意见</span>
      </p>
      <lk-form
        :model="ideaData"
        label-position="right"
        :label-width="100"
        ref="ideaData"
        :rules="ruleValidate">
        <div ref="approvalIdea">
          <lk-form-item label="质量信誉考察意见：" prop="credit" v-if="showCreditView">
            <lk-select clearable v-model.trim="ideaData.credit">
              <lk-option v-for="item in creditList" :key="item.name" :value='item.value'>
                {{item.name}}
              </lk-option>
            </lk-select>
          </lk-form-item>
          <lk-form-item label="审批意见：" prop="idea" :class="{'ivu-form-item-required':this.ruleValidate.idea[0].required}">
            <lk-input :maxlength='40' placeholder='请输入' clearable v-model.trim="ideaData.idea" type="textarea">
            </lk-input>
          </lk-form-item>
        </div>
      </lk-form>
      <div slot="footer">
        <lk-button type="default" size="large"  @click="handleCancel">取消</lk-button>
        <lk-button type="primary" size="large"  @click="handleSubmit('ideaData')" :loading="btnLoading">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import NewBaseFrame from '@/components/frame/NewBaseFrame.vue';
import workflow from '@/services/workflow';
import ApprovalFlow from '@/components/ApprovalFlow';
import utils from '../../libs/utils';

export default {
  components: {
    NewBaseFrame, ApprovalFlow,
  },
  props: {
    workNo: {
      type: String,
    },
    node: [Number, String],
    moduleName: {
      type: String,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    btns: {
      type: Array,
      default: () => [],
    },
    breadcrumb: {
      type: Array,
      default: () => [],
    },
    approvalTabStatus: {
      type: String,
      default: '',
    },
    endStatus: {
      type: String,
      default: '',
    },
    storeInfoId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showQualityOpinions: 2,
      showCreditView: false,
      credit: 0,
      creditList: [{ name: '一般', value: '1' }, { name: '良好', value: '2' }, { name: '优秀', value: '3' }],
      isDone: false,
      able: true,
      titleInfo: [],
      dataInfo: [],
      ideaInput: false,
      ideaData: {
        workNo: '',
        workStatus: '',
        node: '',
        idea: '',
        credit: '',
      },
      ruleValidate: {
        idea: [
          {
            required: false,
            message: '请输入驳回原因',
            trigger: 'blur',
          },
        ],
        credit: [
          {
            required: true,
            message: '请选择质量信誉考察意见',
            trigger: 'change',
          },
        ],
      },
      btnLoading: false,
    };
  },
  computed: {
    computedBtns() {
      // 待审批才展示通过，驳回
      // 审批状态为结束才展示操作日志
      const btns = [];
      if (this.isDone) {
        return btns;
      }
      this.btns.forEach((item) => {
        if (this.approvalTabStatus === this.constApprovalTabStatus.WAIT) {
          if (item.name === 'reject' || item.name === 'pass') {
            btns.push(item);
          }
        }
        if (this.approvalTabStatus === this.constApprovalTabStatus.READY) {
          if (item.name === 'log') {
            btns.push(item);
          }
        }
      });
      return btns;
    },
    constApprovalTabStatus() {
      return this.$store.state.publicParams.approvalTabStatus;
    },
  },
  methods: {
    setAble(val) {
      this.able = val;
    },
    pass() {
      this.ideaData.idea = '';
      const moduleNameRange = [
        'goods',
        'store_supplier',
        'single_purchase_plan', // 计划单
        'single_inspect_reject', // 验收
        'single_receipt_reject', // 拒收
        'single_finance_payable', // 应付单
        'receipt_tax_rate', // 税率审批
        'receipt_tax_rate_reject', // 收货单税率审批（存在拒收）
      ];
      if (moduleNameRange.includes(this.moduleName)) {
        this.ideaData.idea = '同意';
        this.ruleValidate.idea[0].message = '请输入通过原因';
        this.ruleValidate.idea[0].required = true;
      } else {
        this.ruleValidate.idea[0].required = false;
      }
      this.ideaData.node = this.node;
      this.ideaData.workStatus = 1;
      this.ideaData.workNo = this.workNo;
      this.ideaInput = true;
    },
    reject() {
      this.ideaData.idea = '';
      this.ruleValidate.idea[0].required = true;
      this.ruleValidate.idea[0].message = '请输入驳回原因';
      this.ideaData.node = this.node;
      this.ideaData.workStatus = 2;
      this.ideaData.workNo = this.workNo;
      this.ideaInput = true;
    },
    handleSubmit(name) {
      this.credit = this.ideaData.credit;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.$delete(this.ideaData, 'credit');
          workflow.operateIdea(this.ideaData)
            .then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('提交成功');
                this.ideaInput = false;
                setTimeout(() => {
                  this.$router.push({
                    name: 'work',
                  });
                  this.btnLoading = false;
                }, 1000);
              } else {
                this.btnLoading = false;
                this.$Message.error(res.data.error);
              }
            })
            .catch((err) => {
              this.btnLoading = false;
              utils.handleError(err);
            });
        }
        if (this.showCreditView) {
          workflow.operateCreditInfo({ qualityOpinion: this.credit, id: this.storeInfoId })
            .then((res) => {
              if (res.data.status === 200) {
                this.ideaInput = false;
                setTimeout(() => {
                  this.$router.push({
                    name: 'work',
                  });
                  this.btnLoading = false;
                }, 1000);
              } else {
                this.btnLoading = false;
              }
            })
            .catch((err) => {
              this.btnLoading = false;
              utils.handleError(err);
            });
        }
      });
    },
    handleCancel() {
      this.$nextTick(() => {
        this.$refs.ideaData.resetFields();
      });
      this.ideaInput = false;
    },
    handleBtns(btnName) {
      if (btnName === 'reject') {
        this.reject();
        this.showCreditView = false;
      }
      if (btnName === 'pass') {
        this.showCreditView = this.showQualityOpinions == 1;
        this.pass();
      }
      this.$emit('btnClick', btnName);
    },
    attachmentValue(v) {
      this.$emit('attachmentValue', v);
    },
  },
};
</script>

<style scoped>
  .step-padding{
    padding: 25px 0;
    margin-bottom: 20px;
  }
  .info{
    background: #fff;
    padding-bottom: 20px;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
  }
  .info div:first-child{
    color: rgba(0,0,0,0.75);
  }
  .padding-span{
    padding-right:15px;
  }
</style>
